import { TenantStatisticsMetricFindDto, type TenantStatisticsMetricFindInterface } from '@zaoblako/shared/modules/saas/dtos/tenant-statistics/tenant.statistics.metric.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';

/** Tenant statistics response body - DTO signature */
export interface TenantStatisticsFindInterface {
  widgets: TenantStatisticsMetricFindInterface;
  projects: TenantStatisticsMetricFindInterface;
  projectChecklists: TenantStatisticsMetricFindInterface;
  brsTasks: TenantStatisticsMetricFindInterface;
  plannedIncomes: TenantStatisticsMetricFindInterface;
  budgetRequests: TenantStatisticsMetricFindInterface;
  documents1c: TenantStatisticsMetricFindInterface;
  documentsManual: TenantStatisticsMetricFindInterface;
  bankStatementRules: TenantStatisticsMetricFindInterface;
  mailings: TenantStatisticsMetricFindInterface;
  debtors: TenantStatisticsMetricFindInterface;
  creditDebitExclusions: TenantStatisticsMetricFindInterface;
  deals: TenantStatisticsMetricFindInterface;
  erp1cConnections: TenantStatisticsMetricFindInterface;
  companies: TenantStatisticsMetricFindInterface;
  clients: TenantStatisticsMetricFindInterface;
  contragents: TenantStatisticsMetricFindInterface;
  externalUsers: TenantStatisticsMetricFindInterface;
  hdTasks: TenantStatisticsMetricFindInterface;
  users: TenantStatisticsMetricFindInterface;
  userGroups: TenantStatisticsMetricFindInterface;
  workSchedules: TenantStatisticsMetricFindInterface;
  catalogs: TenantStatisticsMetricFindInterface;
  documentVerify: TenantStatisticsMetricFindInterface;
  billVerify: TenantStatisticsMetricFindInterface;
}

/** Tenant statistics response body - DTO schema */
export const TenantStatisticsFindDto = SerdeDtoClass.create<TenantStatisticsFindInterface>(SaasDtoKeysEnum.TENANT_STATISTICS_FIND_DTO, {
  widgets: {
    sortable: true,
    label: 'Виджеты',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  projects: {
    sortable: true,
    label: 'Проекты',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  projectChecklists: {
    sortable: true,
    label: 'Дела',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  brsTasks: {
    sortable: true,
    label: 'Платёжные заявки',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  plannedIncomes: {
    sortable: true,
    label: 'Запланированные доходы',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  budgetRequests: {
    sortable: true,
    label: 'Бюджетные запросы',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  documents1c: {
    sortable: true,
    label: 'Документы 1С',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  documentsManual: {
    sortable: true,
    label: 'Руководства',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  bankStatementRules: {
    sortable: true,
    label: 'Выписки из банков',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  mailings: {
    sortable: true,
    label: 'Рассылки',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  debtors: {
    sortable: true,
    label: 'Должники',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  creditDebitExclusions: {
    sortable: true,
    label: 'Кредит-дебет исключения',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  deals: {
    sortable: true,
    label: 'Сделки',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  erp1cConnections: {
    sortable: true,
    label: 'Подключения к 1С',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  companies: {
    sortable: true,
    label: 'Компании',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  clients: {
    sortable: true,
    label: 'Клиенты',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  contragents: {
    sortable: true,
    label: 'Контрагенты',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  externalUsers: {
    sortable: true,
    label: 'Внешние пользователи',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  hdTasks: {
    sortable: true,
    label: 'Заявки HD',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  users: {
    sortable: true,
    label: 'Пользователи',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  userGroups: {
    sortable: true,
    label: 'Группы пользователей',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  workSchedules: {
    sortable: true,
    label: 'Графики работы',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  catalogs: {
    sortable: true,
    label: 'Справочники',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  documentVerify: {
    sortable: true,
    label: 'Проверяющие документы',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
  billVerify: {
    sortable: true,
    label: 'Проверяющие счета',
    nested: TenantStatisticsMetricFindDto,
    serializer: (_, nested) => nested,
  },
});
